// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Uuid from "uuid";

function generatedUuid(param) {
  return Uuid.v4();
}

export {
  generatedUuid ,
}
/* uuid Not a pure module */
